import { useUpdateActionStatus, ACTION_STATUS } from "@core/features/actions";
import { MeetingDetails } from "@platform/features/video/types/video.types";
import VideoUIJoin from "./VideoUIJoin";
import useMeetingRelatedUserPhaseAction from "@platform/features/video/hooks/useMeetingRelatedUserPhaseAction";

type Props = {
  meetingDetails: MeetingDetails;
  meetingStartTime?: string;
  isDevicesLoading: boolean;
};

export function VideoUIJoinContainer({
  meetingDetails,
  meetingStartTime,
  isDevicesLoading,
}: Props) {
  const meetingAction = useMeetingRelatedUserPhaseAction(
    meetingDetails?.id.toString(),
    meetingDetails?.meeting_type === "meeting_standalone"
      ? "meeting_standalone"
      : "meeting",
    meetingDetails?.program ?? 0
  );

  const completeActionMutation = useUpdateActionStatus({
    actionId: meetingAction?.id ?? 0,
    status: ACTION_STATUS.COMPLETED,
  });

  const onJoinMeeting = async () => {
    completeActionMutation?.mutateAsync();
  };

  return (
    <VideoUIJoin
      meetingDetails={meetingDetails}
      meetingStartTime={meetingStartTime}
      isDevicesLoading={isDevicesLoading}
      onJoinMeeting={onJoinMeeting}
      isActionLoading={false}
    />
  );
}

export default VideoUIJoinContainer;
